<div class="order-sm-points-image" [style.background-image]="'url(' + imageSrc + ')'"></div>
<span class="order-sm-points-content">+{{ points }}</span>
